
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gray-900 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-xl">B</span>
            </div>
            <span className="text-xl font-bold text-gray-900">Bumblebee</span>
          </div>

          <div className="hidden md:flex items-center gap-4">
            <a 
              href="https://optimusdata.typeform.com/to/AdJj1n" 
              target="_blank"
              rel="noopener noreferrer"
              className="px-5 py-2 text-gray-700 hover:text-gray-900 font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              Schedule a Demo
            </a>
            <a 
              href="https://medium.com/hi-bumblebee" 
              target="_blank"
              rel="noopener noreferrer"
              className="px-5 py-2 text-gray-700 hover:text-gray-900 font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              Blog
            </a>
           
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`text-2xl text-gray-900 ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="container mx-auto px-6 py-4 space-y-2">
            <a 
              href="https://optimusdata.typeform.com/to/AdJj1n" 
              target="_blank"
              rel="noopener noreferrer"
              className="block px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg transition-colors cursor-pointer"
            >
              Schedule a Demo
            </a>
            <a 
              href="https://medium.com/hi-bumblebee" 
              target="_blank"
              rel="noopener noreferrer"
              className="block px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg transition-colors cursor-pointer"
            >
              Blog
            </a>
            <a 
              href="/careers" 
              className="block px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg transition-colors cursor-pointer"
            >
              Careers
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
